// extracted by mini-css-extract-plugin
export var button = "button-module--button--nNpGC";
export var disabled = "button-module--disabled--S5EC9";
export var outlined = "button-module--outlined--aid2C";
export var white = "button-module--white--zXP+3";
export var large = "button-module--large--p0bIF";
export var asLink = "button-module--asLink--Ki4Ew";
export var link = "button-module--link--mr3vZ";